import { render, staticRenderFns } from "./BaseClientList.vue?vue&type=template&id=29560dcb&scoped=true"
import script from "./BaseClientList.vue?vue&type=script&lang=js"
export * from "./BaseClientList.vue?vue&type=script&lang=js"
import style0 from "./BaseClientList.vue?vue&type=style&index=0&id=29560dcb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29560dcb",
  null
  
)

export default component.exports